export const USER_ROLES = {
  AdminAbbott: 'abbott_admin',
  AbbottUser: 'abbott_user',
  HcpAdmin: 'hcp_admin',
  HcpUser: 'hcp',
  NonHcpAdmin: 'admin',
} as const;

export type UserRoleValue = (typeof USER_ROLES)[keyof typeof USER_ROLES];

export const USER_ROLE_NAME: Record<UserRoleValue, string> = {
  [USER_ROLES.AdminAbbott]: 'Admin Abbott',
  [USER_ROLES.AbbottUser]: 'Abbott User',
  [USER_ROLES.HcpAdmin]: 'HCP Admin',
  [USER_ROLES.HcpUser]: 'HCP',
  [USER_ROLES.NonHcpAdmin]: 'Non-HCP Admin',
};

export const ALLOWED_ROLE_CREATION: Record<UserRoleValue, UserRoleValue[]> = {
  [USER_ROLES.AdminAbbott]: [
    USER_ROLES.AdminAbbott,
    USER_ROLES.AbbottUser,
    USER_ROLES.NonHcpAdmin,
    USER_ROLES.HcpAdmin,
  ],
  [USER_ROLES.AbbottUser]: [USER_ROLES.NonHcpAdmin, USER_ROLES.HcpAdmin],
  [USER_ROLES.NonHcpAdmin]: [
    USER_ROLES.NonHcpAdmin,
    USER_ROLES.HcpUser,
    USER_ROLES.HcpAdmin,
  ],
  [USER_ROLES.HcpAdmin]: [
    USER_ROLES.NonHcpAdmin,
    USER_ROLES.HcpUser,
    USER_ROLES.HcpAdmin,
  ],
  [USER_ROLES.HcpUser]: [],
};
